import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TooltipsFactory from 'components/tooltips/tooltipsFactory';

class Tooltip extends Component {
    static initTooltip(props = {}) {
        return TooltipsFactory.initTooltip(this, props);
    }

    constructor(props) {
        super(props);

        this.tooltipClassName = this.tooltipClassName.bind(this);
        this.content = this.content.bind(this);
        this.hide = this.hide.bind(this);
    }

    tooltipClassName() {
        if (!!this.props.tooltipClassName) {
            return this.props.tooltipClassName;
        } else {
            return '';
        }
    }

    content() {
        return null;
    }

    classNames() {
        if (!!this.props.classNames) {
            if (Array.isArray(this.props.classNames)) {
                return this.props.classNames.join(' ');
            } else {
                return this.props.classNames;
            }
        } else {
            return '';
        }
    }

    hide() {
        TooltipsFactory.destroyTooltip(this.props.factoryKey);
    }

    render() {
        let sender = this.props.sender;

        if (this.props.hideOnLeaveSender == true) {
            sender.addEventListener('mouseleave', ()=>{
                this.hide();
            });
        }
        if (this.props.hideOnClickOnSender == true) {
            sender.addEventListener('click', ()=>{
                this.hide();
            });
        }

        let rect = sender.getBoundingClientRect();
        let left = parseInt(rect.left + rect.width);
        let top = parseInt(rect.top);

        return (
            <div
                className={`tooltip ${this.tooltipClassName()} ${this.classNames()}`}
                onMouseLeave={()=> {
                    if (this.props.hideOnMouseLeave == true) {
                        this.hide();
                    }
                }}
                onClick={()=> {
                    if (this.props.hideOnClick == true) {
                        this.hide();
                    }
                }}
                style={{
                    left: left,
                    top: top
                }}
            >
                {this.content()}
            </div>
        );
    }
}
Tooltip.propTypes = {
    hideOnMouseLeave: PropTypes.bool,
    hideOnClick: PropTypes.bool,
    hideOnLeaveSender: PropTypes.bool,
    hideOnClickOnSender: PropTypes.bool,
    tooltipClassName: PropTypes.string,
    classNames: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
};
Tooltip.defaultProps = {
    hideOnMouseLeave: true,
    hideOnClick: false,
    hideOnLeaveSender: true,
    hideOnClickOnSender: false
};

export default Tooltip;